// src/hooks/useSessionStorage.ts
export const useSessionStorage = () => {
  const setItem = (key: string, value: string) => sessionStorage.setItem(key, value);
  const getItem = (key: string) => sessionStorage.getItem(key);
  const removeItem = (key: string) => sessionStorage.removeItem(key);

  return { setItem, getItem, removeItem };
};
